import React from "react";

export const IconClose = ({ className = "", fill = "#1C2D3B", height = "16", width = "16", style = {}, ...rest }) => {
  return (
    <svg
      className={`${className}`}
      style={style}
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      {...rest}
    >
      <path
        className="path"
        d="M16 1.61143L14.3886 0L8 6.38857L1.61143 0L0 1.61143L6.38857 8L0 14.3886L1.61143 16L8 9.61143L14.3886 16L16 14.3886L9.61143 8L16 1.61143Z"
        fill={fill}
      />
    </svg>
  );
};
